import { SelectedSortOption } from 'src/types';
import * as copy from '../../constants/copy';

interface FilterMenuLabels {
  filterLabel: string;
  sortLabel: string;
  accessibleFilterLabel: string;
  accessibleSortLabel: string;
  resetAllLabel: string;
  accessibleResetAllLabel: string;
}

export const getFilterMenuLabels = (
  totalSelectedFilterOptionsCount: number,
  selectedSortOption: SelectedSortOption,
): FilterMenuLabels => {
  const resetAllLabel = copy.RESET_ALL;
  const accessibleResetAllLabel = `Reset all filters`;
  const accessibleFilterLabel = `${copy.FILTER_CTA} options (${totalSelectedFilterOptionsCount} selected)`;
  const filterLabel = `${copy.FILTER_CTA}${
    totalSelectedFilterOptionsCount ? ` (${totalSelectedFilterOptionsCount})` : ''
  }`;
  const sortLabel = selectedSortOption ? selectedSortOption.title : copy.SORT_CTA;
  const accessibleSortLabel = `${copy.SORT_BY}${
    selectedSortOption ? ` (${selectedSortOption.title} selected)` : ''
  }`;

  return {
    filterLabel,
    sortLabel,
    accessibleFilterLabel,
    accessibleSortLabel,
    resetAllLabel,
    accessibleResetAllLabel,
  };
};
